import React, { useState } from "react";
import ButtonComponent from "../generic/ButtonComponent";
import { reauthEbay } from "../../api/rest/ebay";
import { REAUTH_WITH_EBAY_CLICKED } from "../../constants/eventsTracked";
import { notify } from "../../helpers/notificationHelpers";
import { parseEbayError } from "../../utils/ebay";

interface ForceReauthoriseButtonProps {
  integration: string;
}

function ForceReauthoriseButton(props: ForceReauthoriseButtonProps) {
  const { integration } = props;
  const [isReauthing, setIsReauthing] = useState(false);

  const handleResyncClick = () => {
    setIsReauthing(true);
    reauthEbay()
      .then(() => {
        notify.info("Successfully reauthenticated with eBay");
      })
      .catch((error: Error) => {
        const message = parseEbayError(error);
        if (message) {
          notify.error(message);
        } else {
          notify.error(
            "Failed to reauthenticate with eBay. Please try again later."
          );
        }
      })
      .finally(() => setIsReauthing(false));
  };

  if (integration !== "ebay") return null;

  return (
    <ButtonComponent
      primary
      disabled={isReauthing}
      onClick={() => handleResyncClick()}
      segmentEventName={REAUTH_WITH_EBAY_CLICKED}
    >
      <i className="fas fa-key" />
      Reauth with eBay
    </ButtonComponent>
  );
}

export default ForceReauthoriseButton;
